import request from 'store/request/actions';
import event from 'utils/event';

export const GET_PREFERENCES_START = `GET_PREFERENCES_START`;
export const GET_PREFERENCES_SUCCESS = `GET_PREFERENCES_SUCCESS`;
export const GET_PREFERENCES_FAILURE = `GET_PREFERENCES_FAILURE`;

export const getPreferencesStart = () => ({
  type: GET_PREFERENCES_START,
});

export const getPreferencesSuccess = (preferences) => ({
  type: GET_PREFERENCES_SUCCESS,
  preferences,
});

export const getPreferencesFailure = (error) => ({
  type: GET_PREFERENCES_FAILURE,
  error,
});

/**
 * Description of the getPreferences action
 */
export const getPreferences = () => async (dispatch) => {
  dispatch(getPreferencesStart());
  try {
    const response = await dispatch(request(`/preferences/`, `GET`));
    dispatch(getPreferencesSuccess(response.data.results));
    return response.data;
  } catch (error) {
    event(`error-preferences`, [`error`, `get-preferences`]);
    dispatch(getPreferencesFailure(error));
    return error.response;
  }
};
